<template>
  <v-container id="bar-container" rounded-sm style="border: 1px solid grey">
    <v-row id="scale-title">
      <v-col class="ml-1">
        <h5>kWh/ha/d</h5>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col class="pa-0">
        <v-sheet id="scale" />
      </v-col>
      <v-col class="pa-0">
        <v-sheet id="bar" rounded style="height: 100%">
          <v-slider v-model="sliderVal" vertical color="black" :max="100" />
        </v-sheet>
      </v-col>
    </v-row>
    <v-row id="auto-adjust-container" class="ml-1">
      <v-col class="ml-1 pa-0">
        <v-checkbox
          v-model="autoAdjust"
          label="auto adjust"
          id="auto-adjust-checkbox"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row v-show="!autoAdjust" id="min-max-value-container" class="ml-1 mr-1">
      <v-col class="ml-1 mr-1 pa-0">
        <v-text-field v-model.number="value.max" dense outlined label="Max:" />
        <v-text-field v-model.number="value.min" dense outlined label="Min:" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
"use strict";

import { select } from "d3-selection";
import { scaleLinear } from "d3-scale";
import { axisLeft } from "d3";

export default {
  name: "ColorBar",
  props: {
    value: Object,
    gradient: Array
  },
  data() {
    return {
      svg: null,
      y: null,
      scaleHeight: null,
      sliderVal: 0,
      autoAdjust: true
    };
  },
  watch: {
    "value.min": function () {
      this.recreateColorBar();
    },
    "value.max": function () {
      this.recreateColorBar();
    },
    sliderVal() {
      this.$emit("colorbar-slider-change", this.sliderVal);
    },
    autoAdjust() {
      this.$emit("setAutoAdjust", this.autoAdjust);
      if (this.autoAdjust) {
        this.recreateColorBar();
        document.getElementById("bar-container").style.height = "350px";
      } else {
        this.recreateColorBar();
        document.getElementById("bar-container").style.height = "500px";
      }
    }
  },
  mounted() {
    this.createScale();
  },
  beforeDestroy() {
    this.$emit("setAutoAdjust", true);
  },
  methods: {
    createScale() {
      this.scaleHeight = 250;
      // document.getElementById("bar-container").offsetHeight -
      // document.getElementById("auto-adjust-container").offsetHeight -
      // document.getElementById("min-max-value-container").offsetHeight -
      // document.getElementById("scale-title").offsetHeight;

      // Adjust height of the colorbar slider bar.
      let colorbarSliderHeight = this.scaleHeight - 10;
      document.getElementsByClassName(
        "v-input__slider--vertical"
      )[0].style.height = colorbarSliderHeight + "px";

      // create svg element
      this.svg = select("#scale")
        .append("svg")
        .attr("width", 60)
        .attr("height", this.scaleHeight);

      // Create the scale
      this.y = scaleLinear()
        .domain([this.value.min, Math.ceil(this.value.max)]) // This is what is written on the Axis: from 0 to 100
        .range([this.scaleHeight - 5, 5]); // Note it is reversed

      // Draw the axis
      this.svg
        .append("g")
        .attr("transform", `translate(50,0)`) // This controls the vertical position of the Axis
        .call(axisLeft(this.y));
      // .append("text")
      // .attr("text-anchor", "end")
      // .attr("stroke", "black")
      // .text("kWh/ha");
    },
    recreateColorBar() {
      // Recreate color bar.
      let svgElements = document.getElementById("scale").children;
      svgElements.forEach(svgElement => {
        svgElement.remove();
      });
      this.svg = null;
      this.y = null;
      this.createScale();
      // this.sliderVal = 0;
    }
  }
};
</script>

<style>
#bar-container {
  position: absolute;
  top: 20%;
  right: 10px;
  height: 350px;
  width: 130px;
  background-color: white;
  padding: 0;
}
#scale {
  height: 100%;
}
#bar {
  height: 100%;
  width: 15px;
  /* margin: 0 auto; */
  background-image: -webkit-linear-gradient(
    to top,
    rgb(255, 255, 255) 0%,
    rgb(0, 0, 255) 25%,
    rgb(0, 255, 0) 50%,
    rgb(255, 255, 0) 75%,
    rgb(255, 0, 0) 100%
  );
  background-image: -moz-linear-gradient(
    to top,
    rgb(255, 255, 255) 0%,
    rgb(0, 0, 255) 25%,
    rgb(0, 255, 0) 50%,
    rgb(255, 255, 0) 75%,
    rgb(255, 0, 0) 100%
  );
  background-image: -o-linear-gradient(
    to top,
    rgb(255, 255, 255) 0%,
    rgb(0, 0, 255) 25%,
    rgb(0, 255, 0) 50%,
    rgb(255, 255, 0) 75%,
    rgb(255, 0, 0) 100%
  );
  background-image: linear-gradient(
    to top,
    rgb(255, 255, 255) 0%,
    rgb(0, 0, 255) 25%,
    rgb(0, 255, 0) 50%,
    rgb(255, 255, 0) 75%,
    rgb(255, 0, 0) 100%
  );
}

.v-input__slot {
  height: 100%;
}
.v-slider.v-slider--vertical {
  height: 100%;
  margin-bottom: 0;
}
</style>
